import getCurrentUrl from './getCurrentUrl';
const getCurrentUrlWithoutPortalId = () => {
  const urlString = getCurrentUrl();
  try {
    const url = new URL(urlString);
    const pathname = url.pathname.replace(/[0-9]/g, '');
    return `${url.origin}${pathname}${url.search}${url.hash}`;
  } catch (e) {
    return '';
  }
};
export default getCurrentUrlWithoutPortalId;